import { useParams } from 'react-router';
import { logger } from '@sanlam-glacier/app-common/modules/logger';
type ProposalUrlParameters = {
  id?: string;
};

export const useProposalIdFromParams = (): number => {
  const { id } = useParams<ProposalUrlParameters>();
  if (id === undefined)
    logger.warning({
      message: 'Proposal ID not found in parameters.',
      includeTrace: true
    });
  return Number(id);
};
